"use client"
import React, {useState} from 'react'
import useShareUrl from "hooks/useShareUrl";
import {ImShare} from "@react-icons/all-files/im/ImShare";
import {VscMultipleWindows} from "@react-icons/all-files/vsc/VscMultipleWindows";
import {FaRegEdit} from "@react-icons/all-files/fa/FaRegEdit";
import TempMessage from "components/TempMessage/TempMessage";
import classes from '../ContentItem.module.scss'
import {BsStarFill} from "@react-icons/all-files/bs/BsStarFill";
import {BsStar} from "@react-icons/all-files/bs/BsStar";
import {useTekstClient} from "../../useTekstClient";
import {useAxios} from "../../useAxios";


export const Menu = ({item, ingelogdeGebruiker, bookmarked}) => {
    const {get} = useAxios()
    const [showKopieMsg, handleDelen] = useShareUrl(false)
    const [bookmark, setBookmark] = useState(bookmarked)
    const {tekst} = useTekstClient()
    const handleBookmark = () => {
        get(`${process.env.NEXT_PUBLIC_BACKEND}/api/wiki/item/bookmark/${item.id}`).then(( ) => {
            setBookmark(!bookmark);
        })
    }


    return <div className={`flex mb-2 gap-2 text-xl pl-10 relative`}>
        <TempMessage
            variant={'info'}
            message={'De link is gekopieerd'}
            show={showKopieMsg}
        />

        <div className={`cursor-pointer hover:text-kleur-cyan`}>
            <ImShare title={tekst('pagina:support:kenniscentrum:lijst-item:menu:delen')} onClick={() => {
            handleDelen(window.location.href)
        }}/>
        </div>


        <div className={`cursor-pointer hover:text-kleur-cyan`}><VscMultipleWindows
            title={tekst('pagina:support:kenniscentrum:lijst-item:menu:Open in nieuw venter')}
            onClick={() => window.open(`/mijn-mkg/support/kenniscentrum/id/${item.id}`, '_blank')}/></div>


        { ingelogdeGebruiker && item.ingelogdeGebruikerMagSchrijven === 1
            && <div className={`cursor-pointer hover:text-kleur-cyan`}><FaRegEdit
                title={tekst('algemeen:Bewerken')}
                onClick={() => {
                    if (item.wiki_vorm_id === 19) {
                        window.open(`/mijn-mkg/beheer/content-management/content/mail/${item.id}`, '_blank')
                        // router.push(`/beheer/content-management/content/mail/${item.id}`)
                    } else if (item.wiki_vorm_id === 10) {
                        window.open(`/mijn-mkg/beheer/content-management/content/media/${item.id}`, '_blank')
                        // router.push(`/beheer/content-management/content/media/${item.id}`)
                    } else {
                        window.open(`/mijn-mkg/beheer/content-management/content/${item.id}`, '_blank')
                        // router.push(`/beheer/content-management/content/${item.id}`)
                    }
                }}
            />
            </div>}
        { ingelogdeGebruiker &&
        <div className={`cursor-pointer hover:text-kleur-cyan`}>
            {bookmark ?
                <BsStarFill className={classes.bookmarkedIcon}
                            onClick={() => handleBookmark(item.id)}
                            title={tekst('pagina:support:kenniscentrum:lijst-item:favoriet:titel')}
                ></BsStarFill>
                :
                <BsStar className={classes.bookmarkIcon + (ingelogdeGebruiker ? '' : ' ' + classes.disabled)}
                        onClick={() => ingelogdeGebruiker && handleBookmark(item.id)}
                        title={!ingelogdeGebruiker && tekst('pagina:support:kenniscentrum:lijst-item:favoriet:inlogvereist')}
                />
            }
        </div>
        }
    </div>
}